module.exports = __webpack_public_path__ + "landing_slider_first_slide_1440x900.2f11e2c.jpg";